export default __webpack_public_path__ + "images/shortlist-card.28add4e0140f73ff8c93.png";